import { LitElement, html } from 'lit-element';
import { PersonJeunessecard } from './person-jeunessecard';

export class ProductJeunessecardItem extends LitElement {

    static get properties() {
        return {
            cartTypeKey: { type: String },
            cartTypeValue: { type: String },
            amount: { type: Number },
            persons: { type: Array }
        };
    }

    constructor(cartTypeKey, cartTypeValue, amount) {
        super();
        this.cartTypeKey = cartTypeKey;
        this.cartTypeValue = cartTypeValue;
        this.amount = amount;
        this.persons = this.generatePersons();
    }

    generatePersons() {
        let persons = new Array();
        for (let index = 0; index < this.amount; index++) {
            switch (this.cartTypeKey) {
                case 'cardClassic':
                    persons.push(new PersonJeunessecard(index+1, true, true, true, false, false));
                    break;
                default:
                    persons.push(new PersonJeunessecard(index+1, true, true, true, true, true));
                    break;
            }
           
        }
        return persons;
    }

    render() {
        return html`
        <h3>${this.cartTypeValue}</h3>
        ${this.persons.map(i => i.render())}
        `;
    }
}
customElements.define('product-jeunessecard-item', ProductJeunessecardItem);